import React from 'react'
import { Accordion } from 'react-bootstrap'
import SpinnerContainer from '../../common/spinner-container'
import UserCourse from './course'
import useYearCourses from './use-user-year-courses'


const UserProfileCourses = ({
    userId,
}) => {
    const { isLoading: isLoadingYearCourses, courses } = useYearCourses( { userId })
    const renderCourse = (course) => {
        return (
            <UserCourse
                userId={userId}
                key={course.id}
                course={course}
            />
        )
    }

    const renderCourses = () => {
        if (isLoadingYearCourses) {
            return ( <SpinnerContainer /> )
        }

        if (!courses.length) {
            return ( <div className='text-center'>There are no experiences found.</div> )
        }

        return (<Accordion>{courses.map(renderCourse)}</Accordion> )
    }

    return (
        <React.Fragment>
            <div style={{ display: 'flex', justifyContent: 'center' }} >
                <div style={{ flexGrow: '1' }}>
                    <span style={{
                        fontSize: '1.2em',
                        fontWeight: 'bold'
                    }}>
                        Experiences
                    </span>
                </div>
            </div>
            <div style={{ paddingTop: '5px'}}>
                {renderCourses()}
            </div>
        </React.Fragment>
    )
}

export default UserProfileCourses